import React, {useContext} from 'react'
import {useHistory} from 'react-router-dom'
import {
    AppContext,
    // forceAppUpdate,
    // _addToEventLog,
    // _setGameLoading,
    // _setGameOver,
} from '../app/app'
import Config from '../launch/config'
import Grid from '@mui/material/Grid'

import './overlay.css'

const GameOverOverlay = () => {
    const history = useHistory()
    const {
        config,
        isGameOver,
        isGameOverOverlayOpen,
        setModalContentType,
        setMinimapOpen,
        toggleGameOverOverlay,
        toggleModal,
    } = useContext(AppContext)

    return (
        <div
            className={`game-over-overlay ${isGameOver &&
                isGameOverOverlayOpen &&
                'game-over-overlay--open'}`}
        >
            <div className="game-over-overlay-inner">
                {config.gameStats.victory ? (
                    <p className="game-over-overlay-heading">
                        Mission Complete
                    </p>
                ) : (
                    <p className="game-over-overlay-heading">Mission Failure</p>
                )}

                {config.gameStats.victory ? (
                    <p style={{color: `#${Config.colorGreen}`}}>
                        You are victorious!
                    </p>
                ) : (
                    <p style={{color: `#${Config.colorRed}`}}>You have lost</p>
                )}

                <Grid container spacing={1} wrap="wrap">
                    <Grid item xs={12} sm={6}>
                        <button
                            className="button-1"
                            onClick={() => {
                                toggleGameOverOverlay()
                                setModalContentType('gameStats')
                                toggleModal()
                                setMinimapOpen(false)
                                Config.minimap && Config.minimap.hide()
                            }}
                        >
                            Mission Overview
                        </button>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <button
                            className="button-1"
                            onClick={() => {
                                history.push('configure')
                            }}
                        >
                            New Mission
                        </button>
                    </Grid>
                </Grid>
            </div>
        </div>
    )
}

export default GameOverOverlay
